'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var errCode = require('err-code');

var CID = require('cids');

var resolve = require('./resolvers');

var last = require('it-last');

var toPathComponents = function toPathComponents() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // split on / unless escaped with \
  return (path.trim().match(/([^\\^/]|\\\/)+/g) || []).filter(Boolean);
};

var cidAndRest = function cidAndRest(path) {
  if (Buffer.isBuffer(path)) {
    return {
      cid: new CID(path),
      toResolve: []
    };
  }

  if (CID.isCID(path)) {
    return {
      cid: path,
      toResolve: []
    };
  }

  if (typeof path === 'string') {
    if (path.indexOf('/ipfs/') === 0) {
      path = path.substring(6);
    }

    var output = toPathComponents(path);
    return {
      cid: new CID(output[0]),
      toResolve: output.slice(1)
    };
  }

  throw errCode(new Error("Unknown path type ".concat(path)), 'ERR_BAD_PATH');
};

var walkPath = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, ipld, options) {
    var _cidAndRest, cid, toResolve, name, entryPath, startingDepth, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _cidAndRest = cidAndRest(path), cid = _cidAndRest.cid, toResolve = _cidAndRest.toResolve;
            name = cid.toBaseEncodedString();
            entryPath = name;
            startingDepth = toResolve.length;

          case 4:
            if (!true) {
              _context.next = 21;
              break;
            }

            _context.next = 7;
            return _awaitAsyncGenerator(resolve(cid, name, entryPath, toResolve, startingDepth, ipld, options));

          case 7:
            result = _context.sent;

            if (!(!result.entry && !result.next)) {
              _context.next = 10;
              break;
            }

            throw errCode(new Error("Could not resolve ".concat(path)), 'ERR_NOT_FOUND');

          case 10:
            if (!result.entry) {
              _context.next = 13;
              break;
            }

            _context.next = 13;
            return result.entry;

          case 13:
            if (result.next) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return");

          case 15:
            // resolve further parts
            toResolve = result.next.toResolve;
            cid = result.next.cid;
            name = result.next.name;
            entryPath = result.next.path;
            _context.next = 4;
            break;

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function walkPath(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var exporter = function exporter(path, ipld, options) {
  return last(walkPath(path, ipld, options));
};

var recursive = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, ipld, options) {
    var node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, child, recurse, _recurse;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _recurse = function _recurse3() {
              _recurse = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, options) {
                var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, file, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, subFile;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _iteratorNormalCompletion2 = true;
                        _didIteratorError2 = false;
                        _context2.prev = 2;
                        _iterator2 = _asyncIterator(node.content(options));

                      case 4:
                        _context2.next = 6;
                        return _awaitAsyncGenerator(_iterator2.next());

                      case 6:
                        _step2 = _context2.sent;
                        _iteratorNormalCompletion2 = _step2.done;
                        _context2.next = 10;
                        return _awaitAsyncGenerator(_step2.value);

                      case 10:
                        _value2 = _context2.sent;

                        if (_iteratorNormalCompletion2) {
                          _context2.next = 53;
                          break;
                        }

                        file = _value2;
                        _context2.next = 15;
                        return file;

                      case 15:
                        if (!file.unixfs.type.includes('dir')) {
                          _context2.next = 50;
                          break;
                        }

                        _iteratorNormalCompletion3 = true;
                        _didIteratorError3 = false;
                        _context2.prev = 18;
                        _iterator3 = _asyncIterator(recurse(file, options));

                      case 20:
                        _context2.next = 22;
                        return _awaitAsyncGenerator(_iterator3.next());

                      case 22:
                        _step3 = _context2.sent;
                        _iteratorNormalCompletion3 = _step3.done;
                        _context2.next = 26;
                        return _awaitAsyncGenerator(_step3.value);

                      case 26:
                        _value3 = _context2.sent;

                        if (_iteratorNormalCompletion3) {
                          _context2.next = 34;
                          break;
                        }

                        subFile = _value3;
                        _context2.next = 31;
                        return subFile;

                      case 31:
                        _iteratorNormalCompletion3 = true;
                        _context2.next = 20;
                        break;

                      case 34:
                        _context2.next = 40;
                        break;

                      case 36:
                        _context2.prev = 36;
                        _context2.t0 = _context2["catch"](18);
                        _didIteratorError3 = true;
                        _iteratorError3 = _context2.t0;

                      case 40:
                        _context2.prev = 40;
                        _context2.prev = 41;

                        if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
                          _context2.next = 45;
                          break;
                        }

                        _context2.next = 45;
                        return _awaitAsyncGenerator(_iterator3.return());

                      case 45:
                        _context2.prev = 45;

                        if (!_didIteratorError3) {
                          _context2.next = 48;
                          break;
                        }

                        throw _iteratorError3;

                      case 48:
                        return _context2.finish(45);

                      case 49:
                        return _context2.finish(40);

                      case 50:
                        _iteratorNormalCompletion2 = true;
                        _context2.next = 4;
                        break;

                      case 53:
                        _context2.next = 59;
                        break;

                      case 55:
                        _context2.prev = 55;
                        _context2.t1 = _context2["catch"](2);
                        _didIteratorError2 = true;
                        _iteratorError2 = _context2.t1;

                      case 59:
                        _context2.prev = 59;
                        _context2.prev = 60;

                        if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                          _context2.next = 64;
                          break;
                        }

                        _context2.next = 64;
                        return _awaitAsyncGenerator(_iterator2.return());

                      case 64:
                        _context2.prev = 64;

                        if (!_didIteratorError2) {
                          _context2.next = 67;
                          break;
                        }

                        throw _iteratorError2;

                      case 67:
                        return _context2.finish(64);

                      case 68:
                        return _context2.finish(59);

                      case 69:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[2, 55, 59, 69], [18, 36, 40, 50], [41,, 45, 49], [60,, 64, 68]]);
              }));
              return _recurse.apply(this, arguments);
            };

            recurse = function _recurse2(_x7, _x8) {
              return _recurse.apply(this, arguments);
            };

            _context3.next = 4;
            return _awaitAsyncGenerator(exporter(path, ipld, options));

          case 4:
            node = _context3.sent;
            _context3.next = 7;
            return node;

          case 7:
            if (!(node.unixfs && node.unixfs.type.includes('dir'))) {
              _context3.next = 42;
              break;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context3.prev = 10;
            _iterator = _asyncIterator(recurse(node, options));

          case 12:
            _context3.next = 14;
            return _awaitAsyncGenerator(_iterator.next());

          case 14:
            _step = _context3.sent;
            _iteratorNormalCompletion = _step.done;
            _context3.next = 18;
            return _awaitAsyncGenerator(_step.value);

          case 18:
            _value = _context3.sent;

            if (_iteratorNormalCompletion) {
              _context3.next = 26;
              break;
            }

            child = _value;
            _context3.next = 23;
            return child;

          case 23:
            _iteratorNormalCompletion = true;
            _context3.next = 12;
            break;

          case 26:
            _context3.next = 32;
            break;

          case 28:
            _context3.prev = 28;
            _context3.t0 = _context3["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 32:
            _context3.prev = 32;
            _context3.prev = 33;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context3.next = 37;
              break;
            }

            _context3.next = 37;
            return _awaitAsyncGenerator(_iterator.return());

          case 37:
            _context3.prev = 37;

            if (!_didIteratorError) {
              _context3.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context3.finish(37);

          case 41:
            return _context3.finish(32);

          case 42:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[10, 28, 32, 42], [33,, 37, 41]]);
  }));

  return function recursive(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

module.exports = exporter;
module.exports.path = walkPath;
module.exports.recursive = recursive;